function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import { Text2 } from "@churchofjesuschrist/eden-text";
import styled from "styled-components";
import { spacing8, spacing16 } from "@churchofjesuschrist/eden-style-constants";
const ParagraphStyled = styled(Text2).withConfig({
  componentId: "sc-a1mtb-0"
})(["margin-block-start:", ";margin-block-end:", ";margin-inline-start:0;margin-inline-end:0;"], spacing8, spacing16);

const P = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(ParagraphStyled, _extends({
    as: "p"
  }, props), children);
};

P.propTypes = {
  /* Paragraph content */
  children: PropTypes.node.isRequired
};
export default P;